import React, { ReactNode } from 'react';

export interface BreadcrumbsProps {
	children: ReactNode;
}

export function Breadcrumbs({ children }: BreadcrumbsProps) {
	return (
		<ul className='mb-3 flex items-start justify-start text-[12px] leading-tight text-cogvio-900 tracking-wide'>
			{children}
		</ul>
	);
}
